import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = {
  key: 0,
  class: "form-empty"
}
const _hoisted_3 = { class: "action" }
const _hoisted_4 = { class: "action-title" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "infos" }
const _hoisted_7 = { class: "actions" }

import { debounce } from "lodash-es";
import { computed, ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";

import { toast } from "@/common/utils/toast";

import {
  analysisSampleList,
  analysisSampleCreate,
  analysisSampleDelete,
} from "@/common/api/rest/analysis/sample";
import { samplePatch } from "@/common/api/rest/sample";
import { analysisMethodList } from "@/common/api/rest/analysis/method";

import type { AnalysisType } from "@/common/types/analysis";
import type { SampleListType, SamplePayloadType } from "@/common/types/sample";

import { sampleForm, searchSample } from "@/components";
import {
  baseConfirm,
  baseModal,
  baseTooltip,
  svgIcon,
} from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'sample',
  props: {
    data: {},
    width: { default: "100%" },
    isEdit: { type: Boolean, default: true }
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const samples = ref<SampleListType[]>([]);
const methods = ref<any[]>([]);

const payload = ref<SamplePayloadType | null>(null);
const selected = ref<any>(null);
const inputSearch = ref("");

const showModalAdd = ref(false);
const showDelConfirm = ref(false);

const ids = computed(() => samples.value?.map((item) => item.sample_id) ?? []);

const methodOptions = computed(() =>
  methods.value.map((item) => ({ option: item.name, value: item.method_id })),
);

function fetchData() {
  if (!props.data?.analysis_id) {
    return;
  }

  analysisSampleList(props.data.account_id, {
    analysis_id: props.data.analysis_id,
    page: 0,
    limit: 100,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        samples.value = data.list;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function fetchMethods() {
  if (!props.data) return;

  analysisMethodList(props.data.account_id, {
    analysis_id: props.data.analysis_id,
    page: 0,
    limit: 100,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        methods.value = data.list;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function update() {
  emit("update-data");
}

function updateSample(sample_id: string, payload: SamplePayloadType) {
  if (!props.data) return;

  samplePatch(props.data.account_id, sample_id, payload)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        update();
        fetchData();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function add() {
  showModalAdd.value = true;
}

function addSelect(data: any[]) {
  selected.value = data[0];
}

function addCancel() {
  inputSearch.value = "";
  selected.value = null;
  showModalAdd.value = false;
}

function addConfirm() {
  if (!props.data || !selected.value) return;

  console.log("selected", selected.value);

  analysisSampleCreate(props.data?.account_id, {
    evaluation_id: props.data.evaluation_id,
    analysis_id: props.data.analysis_id,
    sample_id: selected.value.sample_id,
    sample_name: selected.value.code,
  })
    .then((response) => {
      const { success, message } = response;

      if (success) {
        toast({ message: message, type: "success" });
        addCancel();
        update();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function del(data: SampleListType) {
  showDelConfirm.value = true;
  selected.value = data;
}

function delCancel() {
  showDelConfirm.value = false;
  selected.value = null;
}

function delConfirm() {
  if (!props.data || !selected.value) return;

  analysisSampleDelete(props.data.account_id, selected.value.item_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        toast({ message: message, type: "success" });
        update();
        delCancel();
        fetchData();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

const debounceForm = debounce(updateSample, 1000);

watchEffect(() => {
  fetchData();
  fetchMethods();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["tab-component", { width: __props.width }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (samples.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(t)("analysis.texts.empty_sample")), 1))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(samples.value, (sample, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "item"
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, " Amostra " + _toDisplayString(index + 1), 1),
                (__props.isEdit)
                  ? (_openBlock(), _createBlock(_unref(baseTooltip), {
                      key: 0,
                      position: "relative"
                    }, {
                      trigger: _withCtx(() => [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-none btn-sm remove",
                          onClick: ($event: any) => (del(sample))
                        }, [
                          _createVNode(_unref(svgIcon), {
                            icon: "trash",
                            size: "1.75rem"
                          })
                        ], 8, _hoisted_5)
                      ]),
                      tooltip: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)("common.labels.delete")), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_unref(sampleForm), {
                  data: sample,
                  methods: methodOptions.value,
                  "show-method": true,
                  onUpdateData: ($event: any) => (_unref(debounceForm)(sample.sample_id, $event))
                }, null, 8, ["data", "methods", "onUpdateData"])
              ])
            ]))
          }), 128))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        class: "btn btn-md btn-primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (add()))
      }, _toDisplayString(_unref(t)("common.labels.add").toUpperCase()), 1)
    ]),
    _createVNode(_unref(baseModal), {
      show: showModalAdd.value,
      title: 
        _unref(t)('common.labels.add', {
          concat: _unref(t)('common.labels.sample'),
        }).toUpperCase()
      ,
      "show-button-confirm": true,
      "button-confirm": _unref(t)('common.labels.add'),
      "button-close": _unref(t)('common.labels.cancel'),
      onClose: _cache[1] || (_cache[1] = ($event: any) => (addCancel())),
      onConfirm: _cache[2] || (_cache[2] = ($event: any) => (addConfirm()))
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(searchSample), {
          "account-id": __props.data?.account_id,
          ids: ids.value,
          unic: true,
          onUpdateData: addSelect
        }, null, 8, ["account-id", "ids"])
      ]),
      _: 1
    }, 8, ["show", "title", "button-confirm", "button-close"]),
    _createVNode(_unref(baseConfirm), {
      show: showDelConfirm.value,
      "max-width": "400px",
      title: 
        _unref(t)('common.labels.remove', {
          concat: _unref(t)('common.labels.sample'),
        }).toUpperCase()
      ,
      message: 
        _unref(t)('common.texts.remove_message', {
          concat: payload.value?.name,
        })
      ,
      onCancel: delCancel,
      onConfirm: delConfirm
    }, null, 8, ["show", "title", "message"])
  ], 2))
}
}

})